<template>

  <q-dialog v-model="confirm" persistent>
    <q-card>
      <q-card-section class="row items-center">
        <q-avatar icon="delete" color="negative" text-color="white" />
        <span class="q-ml-sm">Are you sure?</span>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Cancel" color="negative" v-close-popup />
        <q-btn flat label="Delete" color="positive" v-close-popup @click="removeSelectedItems" />
      </q-card-actions>
    </q-card>
  </q-dialog>

  <div class="q-pa-md q-gutter-sm">
    <q-breadcrumbs>
      <q-breadcrumbs-el icon="home" to="/" />
      <q-breadcrumbs-el label="Blacklist" icon="cancel" to="/blacklist" />
      <template v-slot:separator>
        <q-icon
          size="1.5em"
          name="chevron_right"
          color="primary"
        />
      </template>
    </q-breadcrumbs>
  </div>

  <div class="q-pa-md">
    <q-table
      title = "Blacklist"
      :rows = "blacklistItems"
      :columns = "columns"
      row-key = "id"
      selection = "multiple"
      v-model:selected = "selected"
      :loading = "loading"
      :pagination="{ rowsPerPage: 20 }"
      color = "primary"
      :filter="filter"
    >

      <template v-slot:body-cell-actions="scope">
        <q-td :props="scope">
          <q-btn flat round icon="delete" color="negative" @click=removeItem(scope.row.id)>
            <q-tooltip class="bg-negative">Delete</q-tooltip></q-btn>
        </q-td>
      </template>

      <template v-slot:loading>
        <q-inner-loading showing color="primary" />
      </template>
      
      <template v-slot:top>
        <q-btn color="negative" icon="delete" :disable="this.selected.length == 0" label="Remove selected" @click="confirm = true" />
        <q-btn color="positive" icon="add" class="q-ml-lg" label="Add New" to="/blacklist-add" />
        <q-space />
        <q-input  dense debounce="300" color="primary" v-model="filter">
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      
      </q-table>
  </div>
</template>
  
<script>
  import { getRestEndpoint } from '@/utils/utils'
  import { handleClientTokenExpiration, handleTokenExpiration } from '@/utils/auth';
  import axios from "axios";
  import { ref } from 'vue'
  
  export default {
    name: 'BlackList',
    data() {
      return {
        loading: false,
        filter: '',
        selected: [],
        REST_ENDPOINT: '',
        blacklistItems: [],
        columns: [
          { name: 'number', align: 'left', label: 'Number', field: 'bnumber', sortable: true },
          { name: 'actions', align: 'center', label: 'Actions', sortable: false, style: 'width: 150px', },
        ]
      }
    },
    created() {
      handleClientTokenExpiration(this.$router);
    },
    methods: {
      readDataFromAPI() {
        this.loading = true;
        axios
          .get(`${this.REST_ENDPOINT}blacklist`, { withCredentials: true })
          .then((response) => {
            this.loading = false;
            this.blacklistItems = response.data;
          })
          .catch((error) => {
            if (error.response && error.response.status === 401 && error.response.data === 'Token expired') {
              handleTokenExpiration(this.$router);
            } else {
              this.loading = false;
            }
          });
      },
      removeItem(id) {
        if (confirm('Are you sure?')) {
          axios
            .delete(`${this.REST_ENDPOINT}blacklist/${id}`, { withCredentials: true })
            .then(() => {
              this.blacklistItems = this.blacklistItems.filter((item) => item.id !== id);
            })
            .catch((error) => {
              if (error.response && error.response.status === 401 && error.response.data === 'Token expired') {
                handleTokenExpiration(this.$router);
              }
            });
        }
      },
      removeSelectedItems() {
        const deletePromises = this.selected.map((item) =>
          axios.delete(`${this.REST_ENDPOINT}blacklist/${item.id}`, { withCredentials: true })
        );
        Promise.all(deletePromises)
          .then(() => {
            this.blacklistItems = this.blacklistItems.filter(
              (item) => !this.selected.some((selectedItem) => selectedItem.id === item.id)
            );
          })
          .catch((error) => {
            if (error.response && error.response.status === 401 && error.response.data === 'Token expired') {
              handleTokenExpiration(this.$router);
            } 
          });
      }
    },
    mounted() {
      this.REST_ENDPOINT = getRestEndpoint();
      this.readDataFromAPI();
    },
    setup () {
      return {
        confirm: ref(false),
      }
    }
  }
</script>
